<template>
  <div class="kgk-team">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <TeamDetails />
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import TeamDetails from '@/components/user/TeamDetails.vue';

export default {
  name: 'Team',
  components: {
    TeamDetails
  }
}
</script>
